import { Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { ConfigState } from "@/Store/config/types";
const namespace: string = "config";
// extend interface so we dont get compile errors
declare module "vue/types/vue" {
	interface Vue {
		stateconfig: ConfigState;
		settoken(newToken: string): any;
		setuser(userName: string): any;
		setcurrentid(currentid: number): any;
		setaccount(accountid: number): any;
		setapiroot(apiroot: string): any;
		setstore(store: string): any;
		setadmin(admin: boolean): any;
		setthumburl(thumburl: string): any;
	}
}
@Component
export default class StateMixin extends Vue {

	@Action("settoken", { namespace }) private actSetToken: any;
	@Action("setuser", { namespace }) private actSetUser: any;
	@Action("setaccountid", { namespace }) private actAccountId: any;
	@Action("setcurrentid", { namespace }) private actCurrentId: any;
	@Action("setapiroot", { namespace }) private actApiroot: any;
	@Action("setstore", { namespace }) private actStore: any;
	@Action("setadmin", { namespace }) private actAdmin: any;
	@Action("setthumburl", { namespace }) private actionThumbUrl: any;

	public setthumburl(thumburl: string) {
		this.actionThumbUrl(thumburl);
	}
	public get stateconfig(): ConfigState {
		return this.$store.state.config;
	}
	public setstore(store: string) {
		this.actStore(store);
	}
	public settoken(newToken: string) {
		this.actSetToken(newToken);
	}
	public setuser(userName: string) {
		this.actSetUser(userName);
	}
	public setcurrentid(currentid: number) {
		this.actCurrentId(currentid);
	}
	public setaccount(accountid: number) {
		this.actAccountId(accountid);
	}
	public setapiroot(apiroot: string) {
		this.actApiroot(apiroot);
	}
	public setadmin(admin: boolean) {
		this.actAdmin(admin);
	}
}
